module.exports = __webpack_public_path__ + "img/vipox.a4c87af5.png";